import { render, staticRenderFns } from "./manage-alert-edition-add.vue?vue&type=template&id=58948e74&scoped=true"
import script from "./manage-alert-edition-add.vue?vue&type=script&lang=js"
export * from "./manage-alert-edition-add.vue?vue&type=script&lang=js"
import style0 from "./manage-alert-edition-add.vue?vue&type=style&index=0&id=58948e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58948e74",
  null
  
)

export default component.exports